import BaseEntity from '../../BaseEntity';

export default class TripAttribute extends BaseEntity {
    public name: string;
    public icon: string;
    public visible: boolean;

    constructor(json: any) {
        super(json);

        this.name = json.name;
        this.icon = json.icon;
        this.visible = json.visible;
    }

    public toString(): string {
        return this.name;
    }
}
